import { useQuery } from "@tanstack/react-query";
import { getStatistics } from "../openapi/api-client.ts";

export const useStatistics = () =>
  useQuery({
    queryKey: ["statistics"],
    queryFn: async () => {
      const response = await getStatistics();

      if (!response.data) {
        throw new Error(
          `error while fetching statistics: ${response.error.message}`,
        );
      }

      return response.data;
    },
  });
